<i18n>
{
  "en": {
    "edit": "Edit link tree",
    "delete": "Delete link tree",
    "titleRow": "Table number: \"{0}\"",
    "previewQRs": "See QR Codes.",
    "downloadQRs": "Download QR Codes."
  },
  "es": {
    "edit":  "Editar arbol de links",
    "delete":  "Eliminar arbol de links",
    "titleRow": "Mesa numero: \"{0}\"",
    "previewQRs": "Visualizar códigos QR.",
    "downloadQRs":  "Descargar códigos QR."
  }
}
</i18n>
<template>
  <dynameat-row
    :title="title"
    :button-config-list="buttonConfigList"
    :collapse-items="!$vuetify.breakpoint.mdAndUp"
    @editTableQr="onEditTableQr"
    @deleteTableQr="onDeleteTableQr"
    @previewQrCode="onPreviewQrCode"
    @downloadQrCode="downloadQrCode"
    :isClickable="false"
  >
  </dynameat-row>
</template>
<script>
import DynameatRow from '@dynameat/components/DynameatRow';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { TableQr } from '../models';

@Component
@Components({ DynameatRow })
export default class TableQrRow extends Vue {
  @Prop({
    Object,
    validator(tableQr) {
      return tableQr instanceof TableQr;
    }
  }) tableQr;

  get buttonConfigList() {
    return [
      {
        title: `${this.$t('previewQRs')}`,
        icon: 'mdi-qrcode-scan',
        emitName: 'previewQrCode',
      },
      {
        title: `${this.$t('downloadQRs')}`,
        icon: 'mdi-download',
        emitName: 'downloadQrCode'
      },
      {
        title: this.$t('edit'),
        icon: 'mdi-pencil',
        emitName: 'editTableQr',
      },
      {
        title: this.$t('delete'),
        icon: 'mdi-delete',
        emitName: 'deleteTableQr',
      }
    ];
  }

  get title() {
    return this.$t('titleRow', [this.tableQr.number]);
  }

  onEditTableQr() {
    this.$emit('edit');
  }

  onDeleteTableQr() {
    this.$emit('delete');
  }

  onPreviewQrCode() {
    this.$emit('previewQrCode', this.tableQr);
  }

  downloadQrCode() {
    this.$emit('downloadQrCode', this.tableQr);
  }
}
</script>
